import Api from "@/config/Api";

export default {
  // ── SMTP ──
  // business_id explícito: sin esto el backend cae al flag global "selected"
  // de la cuenta, que puede no coincidir con el negocio que se está viendo
  // en el dashboard — mezclando la configuración SMTP entre negocios de una
  // misma cuenta con varios negocios.
  getUserConfigSmtp(businessId) {
    return Api().get("/me/config/smtp", {
      params: { business_id: businessId }
    });
  },
  updateUserConfigSmtp(data, businessId) {
    return Api().post("/me/config/smtp", { ...data, business_id: businessId });
  },

  // ── SMTP alterno para facturas ──
  // Opcional: si no está activo, el envío de facturas sigue usando el SMTP
  // general de arriba. business_id explícito — mismo motivo que SMTP.
  getUserConfigSmtpInvoice(businessId) {
    return Api().get("/me/config/smtp-invoice", {
      params: { business_id: businessId }
    });
  },
  updateUserConfigSmtpInvoice(data, businessId) {
    return Api().post("/me/config/smtp-invoice", {
      ...data,
      business_id: businessId
    });
  },

  // ── Texts / Messages ──
  // business_id explícito — mismo motivo que SMTP (ver comentario arriba).
  getUserConfigTexts(businessId) {
    return Api().get("/me/config/texts", {
      params: { business_id: businessId }
    });
  },
  updateUserConfigTexts(data, businessId) {
    return Api().post("/me/config/texts", { ...data, business_id: businessId });
  },

  // ── Resend sender ──
  getResendSender() {
    return Api().get("/me/config/resend-sender");
  },
  updateResendSender(data) {
    return Api().post("/me/config/resend-sender", data);
  },

  // ── Email template ──
  // business_id explícito — mismo motivo que SMTP (ver comentario arriba).
  getUserConfigEmail(businessId) {
    return Api().get("/me/config/email", {
      params: { business_id: businessId }
    });
  },
  updateUserConfigEmail(data, businessId) {
    return Api().post("/me/config/email", { ...data, business_id: businessId });
  },

  // ── Notification Templates ──
  getNotificationTemplates() {
    return Api().get("/notification-templates");
  },
  getNotificationTemplate(type) {
    return Api().get(`/notification-templates/${type}`);
  },
  upsertNotificationTemplate(type, data) {
    return Api().put(`/notification-templates/${type}`, data);
  },
  deleteNotificationTemplate(type) {
    return Api().delete(`/notification-templates/${type}`);
  },

  // ── Collection & Reminders Config ──
  // business_id explícito — mismo motivo que SMTP (ver comentario arriba).
  getCollectionConfig(businessId) {
    return Api().get("/me/config/collection", {
      params: { business_id: businessId },
      skipErrorNotification: true
    });
  },
  updateCollectionConfig(data, businessId) {
    return Api().patch(
      "/me/config/collection",
      { ...data, business_id: businessId },
      { skipErrorNotification: true }
    );
  },

  // ── WhatsApp Config ──
  getWhatsAppConfig() {
    return Api().get("/whatsapp/config", {
      skipErrorNotification: true
    });
  },
  upsertWhatsAppConfig(data) {
    return Api().post("/whatsapp/config", data);
  },
  testWhatsAppConfig() {
    return Api().post("/whatsapp/config/test");
  },
  sendWhatsAppTest(data) {
    return Api().post("/whatsapp/config/send-test", data);
  },
  updateWhatsAppAutoReply(data, config = {}) {
    return Api().put("/whatsapp/config/auto-reply", data, config);
  },
  disconnectWhatsApp() {
    return Api().post("/whatsapp/config/disconnect");
  },
  updateWhatsAppWabaId(data) {
    return Api().patch("/whatsapp/config/waba-id", data);
  },
  getWhatsAppPhoneStatus() {
    return Api().get("/whatsapp/config/phone-status", {
      skipErrorNotification: true
    });
  },
  requestWhatsAppCode(method = "SMS") {
    return Api().post("/whatsapp/config/request-code", { code_method: method });
  },
  verifyWhatsAppCode(data) {
    return Api().post("/whatsapp/config/verify-code", data);
  },
  getWhatsAppPlatformStatus() {
    return Api().get("/whatsapp/platform-status", {
      skipErrorNotification: true
    });
  },
  connectWhatsAppOAuth(data) {
    return Api().post("/whatsapp/oauth/connect", data, {
      skipErrorNotification: true
    });
  },
  getWhatsAppOAuthUrl(phone, returnUrl) {
    return Api().get("/whatsapp/oauth/redirect", {
      params: { phone, return_url: returnUrl },
      skipErrorNotification: true
    });
  },

  // ── WhatsApp Templates ──
  getWhatsAppTemplates(params = {}) {
    return Api().get("/whatsapp/templates", {
      params,
      skipErrorNotification: true
    });
  },
  createWhatsAppTemplate(data) {
    return Api().post("/whatsapp/templates", data);
  },
  updateWhatsAppTemplate(id, data) {
    return Api().put(`/whatsapp/templates/${id}`, data);
  },
  submitWhatsAppTemplate(id) {
    return Api().post(`/whatsapp/templates/${id}/submit`);
  },
  syncWhatsAppTemplate(id) {
    return Api().post(`/whatsapp/templates/${id}/sync`);
  },
  deleteWhatsAppTemplate(id) {
    return Api().delete(`/whatsapp/templates/${id}`);
  },

  // ── WhatsApp Messages ──
  getWhatsAppMessages(params = {}) {
    return Api().get("/whatsapp/messages", {
      params,
      skipErrorNotification: true
    });
  },
  getWhatsAppMessageStats() {
    return Api().get("/whatsapp/messages/stats", {
      skipErrorNotification: true
    });
  },
  sendWhatsAppMessage(data, config = {}) {
    return Api().post("/whatsapp/messages/send", data, config);
  }
};
